import { useNavigate } from "react-router-dom";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import styled from "styled-components";
import { Button, Typography } from "@mui/material";

import copyLink from "../../../assets/copyLink.webp";
import fb from "../../../assets/social_media/fb.webp";
import instagram from "../../../assets/social_media/instagram.webp";
import linkedin from "../../../assets/social_media/linkedin.webp";
import twitter from "../../../assets/social_media/twitter.webp";
import { COLORS } from "../../../constants/colors";
import { useState } from "react";
import { ROUTES } from "../../../constants/routes";

const socials = [
  {
    icon: fb,
    link: "https://www.facebook.com/sharer/sharer.php?u=www.hailscale.com",
  },
  {
    icon: instagram,
    link: "https://www.instagram.com",
  },
  {
    icon: twitter,
    link: "https://twitter.com/intent/tweet?text=www.hailscale.com",
  },
  {
    icon: linkedin,
    link: "https://www.linkedin.com/shareArticle?mini=true&url=www.hailscale.com&title=Check%20Out%20Hailscale!&summary=&source=",
  },
]

const StyledLinkTitle = styled(Typography)`
  text-transform: uppercase;
  max-width: 75px;
  font-size: 16px !important;
  @media (max-width: 960px) {
    max-width: 100%;
    margin-right: 5px;
  }
`;

const StyledATag = styled.a`
  margin: 0 8px;
  img {
    width: 65px;
  }
  @media (max-width: 960px) {
    margin: 0 4px;
    img {
      width: 29px;
    } 
  }
`;

const StyledCopyLink = styled(Typography)`
  font-size: 26px !important;
  cursor: pointer;
  color: ${COLORS.BLUE};
  text-decoration: underline;
  img {
    height: 24px;
    margin: 0 10px;
    margin-bottom: -4px;
  }

  @media (max-width: 960px) {
    font-size: 16px !important;
    margin-top: 15px;
    img {
      height: 20px;
    }
  }
`;

const StyledOr = styled(Typography)`
margin: 0 10px;
text-transform: uppercase;
@media (max-width: 960px) {
  display: none;
}
`;

const StyledConfirm = styled(Typography)`
  color: ${COLORS.GREEN};
  font-size: 20px !important;
  margin-left: 20px;
  @media (max-width: 960px) {
    font-size: 16px !important;
  }
`;

const StyledBtnCon = styled(Grid)`
  button {
    padding 27px 50px !important;
    @media (max-width: 960px) {
      margin-top: 30px;
      padding 17px 20px !important;
    }
  }
`;

export const Share = () => {

  const [isCopied, setIsCopied] = useState(false);
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();

  const CopyLinkText = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText("www.hailscale.com").then(() => {
        setIsCopied(true);
      })
    } else {
      alert('Browser Not compatible');
    }
  }
  return (
    <Grid container className={isMedium ? "text-align-left" : ""}>
      <Grid container item xs={12} md={9} alignItems="flex-end" justifyContent={isMedium ? "" : "center"}>
        <Grid item xs={12} className="m-b-20">
          <Typography sx={{ fontFamily: "Colfax Regular !important" }} variant="h3" className="m-b-10">Spread the word!</Typography>
          <Typography variant="body2">Know someone who could benefit from Hailscale? Let them know:</Typography>
        </Grid>
        <StyledLinkTitle variant="h6">Share link to:</StyledLinkTitle>
        {socials.map(social => (
          <StyledATag key={social.link} target="_blank" rel="noopener noreferrer" href={social.link}><img src={social.icon} alt="" /></StyledATag>
        ))}
        <StyledOr variant="h6">or</StyledOr>
        <StyledCopyLink onClick={() => CopyLinkText()} variant="h5"><img src={copyLink} alt="" />Copy Link</StyledCopyLink>
        {isCopied &&
          <StyledConfirm variant="h6">Link copied!</StyledConfirm>
        }
      </Grid>
      <StyledBtnCon container item xs={12} md={3} alignItems="center" justifyContent="center">
        <Button
          variant="outlined"
          color="tan"
          onClick={() => navigate(ROUTES.LANDING_PAGE)}
        >Back to home</Button>
      </StyledBtnCon>
    </Grid>
  );
}

export default Share;